import styled from '@emotion/styled'
import { css } from '@emotion/react'

const wrapperStyles = ({ theme }) => css`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${theme.spacings.mega};

  ${theme.media.mega} {
    flex-direction: row;
    justify-content: space-between;
  }
`

const badgesStyles = () => css`
  display: flex;
  gap: 12px;
  flex-shrink: 0;
`

export const Wrapper = styled('div')(wrapperStyles)
export const Badges = styled('div')(badgesStyles)
